interface LastUpdatedLabelProps {
  value: string;
}

export function LastUpdatedLabel({ value }: LastUpdatedLabelProps) {
  const date = new Date(value);
  return <span className="last-updated">Updated {date.toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" })}</span>;
}
